export enum AlertType {
  ERROR = 'error',
  SUCCESS = 'success',
  NONE = 'none'
}

export type AlertConfigs = {
  type: AlertType;
  title?: string;
  description?: string;
  descriptionHtml?: string;
  confirmText?: string;
  cancelText?: string;
  isImage?: boolean;
};
